import React, { useState } from "react";
import "./prosperity.css";
import NewHeader from "../Neweheader";
import grandparents from "../../assets/grandparents.png";
import WilliamImge2 from "../../assets/william-background2.png";
import PowerlineForm from "../powerline/PowerlineForm";
import kingnew from "../../assets/King.png";
import rebon from "../../assets/rebon.png";
import bannerimg from "../../assets/ProsperityRing.png";
import beach from "../../assets/beach-two.png";
import Playicon from "../../assets/playicon.png";
import bigring from "../../assets/ring_big.png";
import logo from "../../assets/logo.png"
import VideoPlayer from "../../Common/Components/VideoPlayer";
import headerLogo from '../../assets/headerlogo.png';
import { useNavigate } from 'react-router-dom';
import { storeAssigned } from '../../services/Methods/normalMethods';
import footerlogo from '../../assets/footer-image.png';
import VisitorList from "../../Common/Components/VisitorComponent";


const Prosperity = () => {
    const sections = [
        {
            number: "1",
            title: "RETAIL COMMISSIONS (Paid Weekly)",
            description:
                "Receive up to 30% profit on all registered Retail Customer purchases which includes the Loyalty Promotion. OR - Buy product at wholesale and sell at retail. Retail profits vary based on wholesale per unit price in your specific Pack purchased.",
        },
        {
            number: "2",
            title: "SPONSOR COMMISSIONS (Paid Weekly)",
            description:
                "When you enroll a new Provizion Affiliate you will receive up to 20% of their Product Volume (PV*) every time they order for their entire first year.",
        },
        {
            number: "3",
            title: "TEAMS COMMISSION (Paid Weekly)",
            description:
                "Team Commissions are paid as up to 10% of your Total Sponsor Team Volume (PV*). You must be Team Affiliate qualified by having sponsored 1 or more Affiliates who have ordered 50PV* of product.",
        },
        {
            number: "4",
            title: "GENERATION COMMISSION (Paid Weekly)",
            description:
                "Based on your weekly Team Affiliate qualification of having 4 Active Affiliates with orders of 50PV* each, you will receive up to a 10% MATCH of the Team Commissions earned by your Sponsor Team Affiliates up to 4 levels deep. This includes compression (bypass) of inactive Affiliates. This commission will not exceed 10% of Total Sponsor Volume.",
        },
        {
            number: "5",
            title: "LEGACY PARTNER INCENTIVE (Paid Monthly)",
            description:
                `Your Sponsor Earnings on Legacy & Master Packs are doubled when as a Qualified Team Affiliate you Sponsor 2 new “Legacy Partners” or 4 or more new "Master Partners" within the same Calendar Month. You must have purchased your own Legacy pack or 2 Master Packs within the last 52 weeks to qualify for this incentive.`,
        },
        {
            number: "6",
            title: "LEGACY LEADERSHIP INCENTIVE (Paid Monthly)",
            description:
                `Receive 1 share of the LegacyLine Pool, which is 4% of total company sales, for each separate Sponsor Team that produces 1000PV* in a single week. You may earn an unlimited number of shares of the LegacyLine Pool. Your shares are multiplied by a percentage of the entire product volume generated by all Affiliates below your position in the LegacyLine.`,
        },
        {
            number: "7",
            title: "REWARDS",
            description:
                `Provizion may also offer additional rewards, such as: Mobile Phones; Tablets; Computers; Leadership Dinners, Special Executive Trainings; FREE Registrations, and Travel and Lodging for our Global & Regional Conventions and Leadership Summits.</br></br>*PV = a percentage of the price of each product sold from which commissions are paid to Affiliates.`,
        },
    ];


    const [activeVideo, setActiveVideo] = useState(null);

    const videos = {
        legacyLine: "https://player.vimeo.com/video/1089904998?autoplay=0&title=0&amp;byline=0&amp;portrait=0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
        Commission: "https://player.vimeo.com/video/1083206386?title=0&amp;byline=0&amp;portrait=0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",

    };

    const handlePdf = () => {
        const link = document.createElement('a');
        link.href = '/api/Files/documents/CompPlan.pdf';
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const navigate = useNavigate();
    return (
        <>
            <section className='bg-[#fff] relative'>
                <img className=' absolute top-0 left-0 w-full z-[1] xl:h-[1160px] lg:h-[960px] md:h-[730px] h-[630px] object-cover' src={bannerimg} alt="" />
                <div className='xl:h-[820px] lg:h-[720px] md:h-[600px] h-[520px] container xl:max-w-[1380px] mx-auto px-[15px] relative z-[2]'>
                    <div className="wraper-div flex md:justify-between justify-center h-full flex-wrap">
                        <div className="left xl:pt-[109px] pt-[30px] relative lg:left-[150px] md:left-[50px] left-[15px] md:w-auto w-full">
                            <h2 className='font-osw text-[#5E5E5E] xl:text-[90px] xl:leading-[90px] lg:text-[60px] lg:leading-[70px] md:text-[50px] md:leading-[60px] text-[40px] leading-[50px]'>PROSPERITY</h2>
                            <h3 className='font-osw text-[#5E5E5E] xl:text-[60px] xl:leading-[90px] lg:text-[40px] lg:leading-[60px] text-[30px] leading-[40px] md:text-center xl:mt-[30px] mt-[15px]'>System</h3>
                        </div>
                        <div className="right max-w-[460px] mt-auto pb-[200px] relative lg:right-[200px] right-[15px] w-full">
                            <h3 className='lg:text-[40px] lg:leading-[50px] text-[30px] leading-[40px] text-[#5E5E5E] text-center  font-semibold  '>
                                THE ABILITY TO <br />MAKE A DIFFERENCE
                            </h3>
                        </div>
                    </div>
                </div>
            </section>

            <section className='our-goal-sec bg-no-repeat bg-center bg-cover' style={{ backgroundImage: `url(${beach})`, backgroundPosition: "center top" }}>

                <div className='xl:h-[987px] lg:h-[800px] h-[500px] container xl:max-w-[1380px] mx-auto px-[15px] relative'>
                    <div class="right-div max-w-[415px] w-full text-center absolute top-[180px] -translate-y-[50%]  right-[20px] italic"><p class="text-[#fff] font-semibold md:text-[30px] md:leading-[36px] text-[25px] leading-[34px]">“The legacy we leave is not just in our possessions, but in the quality of our lives.” </p><p class="font-semibold text-[#fff] md:text-[30px] leading-[30px] text-[25px] mt-[30px]">— Billy Graham</p></div>

                </div>
            </section>


            <section className="main main_purpose xl:pt-[124px] lg:pt-[100px] md:pt-[70px] pt-[50px] bg-no-repeat bg-center" style={{ backgroundImage: `url(${bigring})`, backgroundPosition: "center top" }}>
                <div className='container max-w-[1380px] mx-auto px-[15px]'>

                    <h2 className="xl:mb-[214px] lg:mb-[100px] md:mb-[80px] mb-[30px] font-osw xl:text-[90px] xl:leading-[80px] text-[#5E5E5E] text-center lg:text-[80px] lg:leading-[70px] md:text-[50px] md:leading-[40px] text-[40px] leading-[30px]">PROSPERITY <br /> <span className="xl:text-[70px] xl:leading-[70px]  lg:text-[60px] lg:leading-[70px] md:text-[40px] md:leading-[50px] text-[30px] leading-[40px]">SYSTEM</span></h2>
                    <div className="main-wraper">
                        <div className="video-warper bg-[#f2f4fae8] shadow-[3px_3px_16px_#00000029] lg:p-[50px_20px] p-[30px_15px]">


                            <div className="inner max-w-[1220px] mx-auto">
                                <div className="discr">
                                    <h3 className="xl:text-[48px] xl:leading-[65px] lg:text-[40px] lg:leading-[50px] md:text-[35px] md:leading-[45px] text-[28px] leading-[38px] font-normal text-[#000] text-center mb-[16px]">LEGACYLINE OVERVIEW</h3>
                                    <p className="mb-[30px] xl:text-[30px] xl:leading-[40px] lg:text-[25px] lg:leading-[35px] md:text-[20px] md:leading-[30px] text-[18px] leading-[28px] font-normal text-[#000] text-center">Discover how our LegacyLine System helps support your earnings potential - from Invitation to Follow-up to Team Building.</p>
                                </div>
                                {/* {activeVideo === "legacyLine" ? ( */}
                                <div className="w-full pb-[56%] relative comon_video">
                                    <VideoPlayer url={videos.legacyLine} className="w-full h-full rounded-lg" />
                                </div>
                                {/* ) : (
                                     <div className="video mt-[78px]">
                                         <div className="video-inner min-h-[444px] bg-white border border-[#707070] relative">
                                             <img
                                                 onClick={() => setActiveVideo("legacyLine")}
                                                 className="w-[88px] h-[88px] absolute top-[50%] left-[50%] -translate-x-[50%] -translate-y-[50%] cursor-pointer" src={Playicon} alt="" />
                                         </div>
                                     </div>
                                 )} */}

                            </div>

                        </div>

                        <div className="xl:mt-[107px] lg:mt-[90px] md:mt-[80px] mt-[40px] video-warper bg-[#f2f4fae8] shadow-[3px_3px_16px_#00000029] xl:p-[50px_20px] md:p-[30px_20px] p-[20px_15px]">
                            <div className="inner max-w-[1220px] mx-auto">
                                <div className="discr">
                                    <h3 className="xl:text-[48px] xl:leading-[65px] lg:text-[40px] lg:leading-[50px] md:text-[35px] md:leading-[45px] text-[28px] leading-[38px] font-normal text-[#000] text-center mb-[16px]">COMMISSION OVERVIEW</h3>

                                </div>
                                {/* {activeVideo === "Commission" ? ( */}
                                <div className="w-full pb-[56%] relative comon_video">
                                    <VideoPlayer url={videos.Commission} className="w-full h-full rounded-lg" />
                                </div>
                                {/* ) : (
                                    <div className="video mt-[78px]">
                                        <div className="video-inner min-h-[444px] bg-white border border-[#707070] relative">
                                            <img
                                                onClick={() => setActiveVideo("Commission")}
                                                className="w-[88px] h-[88px] absolute top-[50%] left-[50%] -translate-x-[50%] -translate-y-[50%] cursor-pointer" src={Playicon} alt="" />
                                        </div>
                                    </div>
                                )} */}
                            </div>
                        </div>

                        <div className="xl:mt-[107px] lg:mt-[90px] md:mt-[80px] mt-[40px] video-warper bg-[#f2f4fae8] shadow-[3px_3px_16px_#00000029] xl:p-[50px_0px] md:p-[30px_0px] p-[20px_0px]">
                            <div className="inner max-w-full mx-auto">
                                <div className="discr">
                                    <img className='xl:max-w-[311px] lg:max-w-[250px] md:max-w-[200px] max-w-[100px] block h-full w-full object-contain mx-[auto] mb-[15px]' src={headerLogo} alt="logo" />
                                    <h3 className="font-osw xl:text-[50px] xl:leading-[65px] font-light text-[#000] text-center mb-[16px] lg:text-[40px] lg:leading-[50px] md:text-[35px] md:leading-[45px] text-[28px] leading-[38px] ">COMPENSATION OVERVIEW & INCENTIVES</h3>
                                    <button className="bg-[#0071BA] text-white xl:text-[24px] xl:leading-[45px] md:text-[20px] md:leading-[40px] text-[18px] leading-[30px] font-normal p-[8px_15px]  max-w-1/2 w-full text-[#fff] transition delay-150 duration-300 ease-in-out cursor-auto">All Commissions Are Paid In US Dollars</button>
                                </div>

                                <div className="video xl:mt-[78px] lg:mt-[60px] mt-[30px]">
                                    <div className="numb-inner flex lg:gap-[40px] gap-[20px] flex-wrap px-[15px]">
                                        {[0, 1].map((col) => (
                                            <div key={col} className="lg:w-[calc(100%/2-20px)] md:w-[calc(100%/2-10px)] w-full">
                                                {sections.slice(col * 4, col * 4 + 4).map((item) => (
                                                    <div key={item.number} className="wraper flex gap-[17px] items-start md:mb-[40px] mb-[15px]">
                                                        <div className="num text-[#FFC600] xl:text-[200px] lg:text-[150px] md:text-[100px] text-[40px] drop-shadow-[0px_3px_6px_#00000029] leading-[0.8]">
                                                            {item.number}
                                                        </div>
                                                        <div className="disc">
                                                            <h3 className="xl:text-[24px] xl:leading-[30px] text-[20px] leading-[30px] text-[#000] font-semibold mb-[11px]">
                                                                {item.title}
                                                            </h3>
                                                            <p className="xl:text-[20px] text-[#000] xl:leading-[30px] md:text-[18px] md:leading-[28px] text-[16px] leading-[25px]" dangerouslySetInnerHTML={{ __html: item.description }}></p>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        ))}
                                    </div>
                                </div>


                            </div>
                        </div>

                        <div className="btn-wrapper flex justify-start xl:gap-[100px] xl:mt-[73px] lg:gap-[50px] lg:mt-[50px] gap-[20px] mt-[30px]  md:flex-nowrap flex-wrap">
                            {/* <button onClick={handlePdf} className="bg-[#0071BA] tex-white xl:text-[24px] xl:leading-[55px] md:text-[20px] md:leading-[40px] text-[18px] leading-[30px] font-normal p-[8px_15px] max-w-[470px] w-full text-[#fff] uppercase transition delay-150 duration-300 ease-in-out hover:bg-black shadow-[3px_3px_8px_#00000029]">COMMISSION PLAN OVERVIEW</button> */}
                            <button className="bg-[#0071BA] tex-white xl:text-[24px] xl:leading-[55px] md:text-[20px] md:leading-[40px] text-[18px] leading-[30px] font-normal p-[8px_15px] max-w-[470px] w-full text-[#fff] uppercase transition delay-150 duration-300 ease-in-out hover:bg-black shadow-[3px_3px_8px_#00000029] z-[99]" onClick={() => window.open(`/api/Files/documents/FAQs_Products.pdf`, '_blank')}>FREQUENTLY ASKED QUESTIONS</button>
                        </div>

                    </div>
                </div>

            </section>


            {/* <section className='pt-[100px] relative z-[2]'>
                <div className='container max-w-[1490px] mx-auto px-[15px]'>


                </div>
                <div className='img'>
                    <img className="mx-auto relative -top-[100px]" src={rebon} alt="king" />
                </div>
            </section>

            <section className='md:p-[130px_0_137px] p-[130px_0_80px] bg-no-repeat bg-center bg-cover relative -mt-[200px] z-[1]' style={{ backgroundImage: `url(${WilliamImge2})`, backgroundSize: "1530px", backgroundPosition: "center top" }}>
                <div className='overlay absolute top-[90px] left-0 w-full h-[calc(100%-150px)] bg-[#F6F7FB] opacity-[0.57] z-[1]'></div>
                <div className='container max-w-[1380px] mx-auto px-[15px] relative z-[2]'>

                    <div className="title">
                        <h2 className="font-osw text-[#000000] xl:text-[70px] lg:text-[60px] md:text-[50px] text-[30px] font-normal text-center font-osw xl:leading-[104px] lg:leading-[70x] mg:leading-[60x] leading-[40x]">YOUR LEGACY IS WAITING FOR YOU</h2>
                        <h3 className='xl:text-[50px] xl:leading-[60px] lg:text-[40px] lg:leading-[30px] text-[28px] leading-[38px] text-[#000000] text-center md:mt-[27px] mt-[18px] md:mb-[25px] mb-[18px]     '>And We’ll Help Create It </h3>
                        <h3 className='xl:mb-[37px] mb-[25px] xl:text-[50px] xl:leading-[60px] lg:text-[40px] lg:leading-[30px] text-[28px] leading-[38px] text-[#000000] text-center'>INSTANT ACCESS</h3>
                    </div>

                    <div className="form">
                        <PowerlineForm />
                    </div>
                    <p className='xl:text-[24px] lg:text-[20px] text-[18px] mx-auto pt-[46px] text-center leading-[30px] text-[#000] max-w-[1096px]'>When you click the gold Instant Access button above we will immediately email your digital copy of Dr. Greenman’s highly acclaimed book, <b className='italic'>Absolute Certainty.</b></p>


                </div>
            </section> */}

            <section className='xl:pt-[0px] lg:pt-[10px] pt-[0px] relative z-[2]'>
                <div className='container mx-auto chosse-legecy-section flex pt-[40px] 2xl:z-[1] z-[3] relative lg:flex-nowrap flex-wrap'>
                    <div className='choose-legacy-heading text-center xl:w-[60%] lg:w-[50%] w-full'>
                        <h2 className='lg:text-right text-center lg:pr-[100px] pr-0 lg:mb-0 mb-[30px] font-osw xl:text-[50px] xl:leading-[90px] lg:text-[40px] lg:leading-[50px] md:text-[35px] md:leading-[40px] text-[30px] leading-[40px]'>Choose your legacy</h2>
                    </div>
                    <div className='visitors-section xl:pt-[120px] lg:pt-[0px] xl:pl-[50px] pl-[15px] xl:w-[40%] lg:w-[50%] w-full'>
                        <VisitorList />
                    </div>
                </div>
                <div className="btn-wrapper flex justify-center xl:gap-[100px] xl:mt-[73px] lg:gap-[50px] lg:mt-[50px] gap-[20px] mt-[30px]  md:flex-nowrap flex-wrap">
                    <button className="bg-[#0071BA] tex-white xl:text-[24px] xl:leading-[55px] md:text-[20px] md:leading-[40px] text-[18px] leading-[30px] font-normal p-[8px_15px] max-w-[470px] w-full text-[#fff] uppercase transition delay-150 duration-300 ease-in-out hover:bg-black shadow-[3px_3px_8px_#00000029]" onClick={() => window.open(`/api/Files/documents/LegcyLine_Overview_text.pdf`, '_blank')}>LEGACY OVERVIEW</button>
                </div>
                <div className='img 2xl:z-[2] z-[1] relative'>
                    <img className="mx-auto relative 2xl:-top-[815px] xl:-top-[720px] -top-[0px]" src={rebon} alt="king" />
                </div>
            </section>

            <section className='lg:p-[130px_0_137px] p-[100px_0_50px]  bg-no-repeat bg-center bg-cover relative xl:-mt-[500px] lg:-mt-[100px] -mt-[80px] z-[99]' style={{ backgroundImage: `url(${WilliamImge2})`, backgroundSize: "1530px", backgroundPosition: "center top" }}>
                <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 xl:gap-8 gap-3 px-[15px]">

                    <div className="border p-6 bg-white flex flex-col items-center">
                        {/* <div className="btn-wrapper flex justify-center xl:gap-[100px] xl:mt-[73px] lg:gap-[50px] lg:mt-[50px] gap-[20px] mt-[30px]  md:flex-nowrap flex-wrap">
                                                    <button className="bg-[#0071BA] tex-white xl:text-[24px] xl:leading-[55px] md:text-[20px] md:leading-[40px] text-[18px] leading-[30px] font-normal p-[8px_15px] max-w-[470px] w-full text-[#fff] uppercase transition delay-150 duration-300 ease-in-out hover:bg-black shadow-[3px_3px_8px_#00000029]">LEGACY OVERVIEW</button>
                                     </div>
                                     <div className="btn-wrapper flex justify-center xl:gap-[100px] lg:gap-[50px] gap-[20px] md:flex-nowrap flex-wrap">
                                                    <button className="bg-[#0071BA] tex-white xl:text-[24px] xl:leading-[55px] md:text-[20px] md:leading-[40px] text-[18px] leading-[30px] font-normal p-[8px_15px] max-w-[470px] w-full text-[#fff] uppercase transition delay-150 duration-300 ease-in-out hover:bg-black shadow-[3px_3px_8px_#00000029]">LEGACY OVERVIEW</button>
                                     </div> */}
                        <div className='md:max-w-[450px] max-w-full w-full mx-auto'>
                            <button className="cursor-pointer bg-[#0071BA] text-white w-full text-center py-3 font-semibold text-lg mb-4" onClick={() => window.location.href = `/${storeAssigned()}/retail_signup`}>
                                BECOME A RETAIL CUSTOMER
                            </button>
                            <img src="/Images/retailcustomer.jpg" alt="Retail Customer" className="mb-4" />
                            <ul className="list-disc pl-5 text-black space-y-2 text-sm font-semibold">
                                <li className="font-semibold">Purchase Provizion products whenever you wish, from your store within this website</li>
                                <li>Access to Purpose International’s samples, discounted materials, and courses.</li>
                                <li>Access to samples and discounts on Dr. Greenman’s desk reference book on Glutathione.</li>
                            </ul>
                        </div>
                    </div>

                    <div className="border p-6 bg-white flex flex-col items-center">
                        <div className='md:max-w-[450px] max-w-full w-full mx-auto'>
                            <button className="bg-[#0071BA] text-white w-full text-center py-3 font-semibold text-lg mb-4" onClick={() => window.location.href = `/${storeAssigned()}/business_owner`}>
                                BECOME A WHOLESALE AFFILIATE
                            </button>
                            <img src="/Images/wholesale.jpg" alt="Wholesale Affiliate" className="mb-4" />
                            <ul className="list-disc pl-5 text-black space-y-2 text-sm font-semibold">
                                <li>New Affiliates who were sponsored by Affiliates above you will be placed into your LegacyLine Team.</li>
                                <li>Sponsor New Affiliates and Retail Customers of your own.</li>
                                <li>Purchase Provizion products when you wish, from the back-office area of your Affiliate website.</li>
                                <li>Sell products to anyone at Retail pricing and keep the profit.</li>
                                <li>Receive Commissions, Bonuses, and Rewards.</li>
                                <li>Access to all Affiliate personal and business training materials.</li>
                            </ul>
                        </div>
                    </div>
                </div>


                {/* <div className='overlay absolute top-[90px] left-0 w-full h-[calc(100%-150px)] bg-[#F6F7FB] opacity-[0.57] z-[1]'></div>
                                        <div className='container xl:max-w-[1380px] mx-auto px-[15px] relative z-[2]'>
                                            <div className="title">
                                                <h2 className="font-osw text-[#000000] xl:text-[70px] lg:text-[60px] md:text-[50px] text-[30px] font-normal text-center font-osw xl:leading-[104px] lg:leading-[70x] mg:leading-[60x] leading-[40x]">YOUR LEGACY IS WAITING FOR YOU</h2>
                                                <h3 className='xl:text-[50px] xl:leading-[60px] lg:text-[40px] lg:leading-[30px] text-[28px] leading-[38px] text-[#000000] text-center md:mt-[27px] mt-[18px] md:mb-[25px] mb-[18px]     '>And We’ll Help Create It </h3>
                                                <h3 className='xl:mb-[37px] mb-[25px] xl:text-[50px] xl:leading-[60px] lg:text-[40px] lg:leading-[30px] text-[28px] leading-[38px] text-[#000000] text-center'>INSTANT ACCESS</h3>
                                            </div>
                        
                                            <div className="form">
                                                <PowerlineForm />
                                            </div>
                                            <p className=
                                            
                                            'xl:text-[24px] lg:text-[20px] text-[18px] mx-auto pt-[46px] text-center leading-[30px] text-[#000] max-w-[640px]'>We will immediately email your digital copy of Dr. Greenman’s highly acclaimed book, <b className='italic'>Absolute Certainty.</b></p>
                                        </div> */}


                <div className="bg-[#f3f4f6f2] container max-w-6xl mx-auto mt-[40px]">
                    <div className="xl:p-[40px] md:p-[20px] p-[25px_15px]">
                        <h2 className="font-osw xl:text-[40px] lg:text-[35px] text-[30px] leading-[1.2] text-center xl:mb-12 mb-4">
                            AFFILIATE AMENITIES
                        </h2>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-start">

                            <div>
                                <ul className="text-black text-lg">
                                    {[
                                        { title: "LegacyLine", desc: "position and invitation link" },
                                        { title: "Quality of Life", desc: "chart for tracking health/longevity" },
                                        { title: "Personal Affiliate", desc: "website" },
                                    ].map((item, index) => (
                                        <li key={index} className="flex items-start gap-3">
                                            <i className="fa fa-check text-yellow-500 text-2xl mt-1" aria-hidden="true"></i>
                                            <span>
                                                <strong>{item.title}</strong> {item.desc}
                                            </span>
                                        </li>
                                    ))}

                                    <li className="flex items-start gap-3">
                                        <i className="fa fa-check text-yellow-500 text-2xl mt-1" aria-hidden="true"></i>
                                        <div>
                                            <strong>TeamProvizion.com</strong>
                                            <ul className="list-disc pl-6 mt-2 text-base space-y-1">
                                                <li>Personal Purpose Materials</li>
                                                <li>LegacyLine Training</li>
                                                <li><strong>Media Library</strong> of approved marketing tools</li>
                                                <li>Graphics</li>
                                                <li>Product fliers</li>
                                                <li>Videos</li>
                                                <li>Pop up banners</li>
                                                <li>and More!</li>
                                            </ul>
                                        </div>
                                    </li>

                                    {[
                                        { title: "Access", desc: "Your Kingdom Purpose Blueprint - Module 1: our faith-based video series" },
                                        { title: "Access chapters 1-4 of", desc: "Master Keys Of Life: our standard life course materials" },
                                        { title: "Access 70 pages of", desc: "Glutathione: King of The Master: Molecules of Health, Dr. Bill Greenman's book" },
                                        { title: "Access", desc: "The Legacy Podcast – weekly interviews, product and business building insights" },
                                    ].map((item, index) => (
                                        <li key={`access-${index}`} className="flex items-start gap-3">
                                            <i className="fa fa-check text-yellow-500 text-2xl mt-1" aria-hidden="true"></i>
                                            <span>
                                                {item.title} <strong>{item.desc}</strong>
                                            </span>
                                        </li>
                                    ))}

                                </ul>
                            </div>

                            <div className="flex justify-center relative">
                                <div className="flex flex-col items-center space-y-6">
                                    <img
                                        src="/Images/books.png"
                                        alt="Blueprint"
                                        className="w-100"
                                    />

                                </div>
                            </div>

                        </div>
                    </div>
                </div>

            </section>
        </>
    );
};

export default Prosperity;
